import { Grid, Typography } from '@mui/material';
import { PortalTelemetryScreen } from '../../../app/telemetry/portalTelemetryScreens';
import cpdCategoriesFormModel from './cpdCategoriesFormModel';

export type CpdFormMode = 'Add' | 'Update' | 'Clone';

const { AccreditedCeActivity, PracticeReview, WorkbasedLearning } = cpdCategoriesFormModel.formField;

export const cpdFormConfig = {
    Add: {
        screen: PortalTelemetryScreen.AddCpdForm,
        title: 'Add record',
        description: <>
            <Grid container sx={{ marginLeft: "2%", marginTop: "2%" }}>
                <Grid size={{ xs: 12 }} sx={{ marginBottom: "2%" }}>
                    <Typography variant='subtitle1'>Activity category descriptions</Typography>
                </Grid>
                <Grid size={{ xs: 5, md: 3, sm: 4 }}>
                    <Typography variant='subtitle1'><b>{AccreditedCeActivity.label}: </b></Typography>
                </Grid>
                <Grid size={{ xs: 7, md: 9, sm: 8 }}>
                    <Typography variant='subtitle1'>{AccreditedCeActivity.informationText}</Typography>
                </Grid>
                <Grid size={{ xs: 5, md: 3, sm: 4 }}>
                    <Typography variant='subtitle1'><b>{WorkbasedLearning.label}: </b></Typography>
                </Grid>
                <Grid size={{ xs: 7, md: 9, sm: 8 }}>
                    <Typography variant='subtitle1'>{WorkbasedLearning.informationText}</Typography>
                </Grid>
                <Grid size={{ xs: 5, md: 3, sm: 4 }}>
                    <Typography variant='subtitle1'><b>{PracticeReview.label}: </b></Typography>
                </Grid>
                <Grid size={{ xs: 7, md: 9, sm: 8 }}>
                    <Typography variant='subtitle1'>{PracticeReview.informationText}</Typography>
                </Grid>
            </Grid>
            <Grid container rowSpacing={2} sx={{ marginLeft: "2%", marginTop: "2%" }}>
                <Grid size={{ xs: 12 }}>
                    <Typography variant='subtitle1'><i>* Please note detailed description of CPD activities
                        are available through PCS guidelines on relevant scheme websites.</i></Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Typography variant='subtitle1'>Please add your CPD activity details below.</Typography>
                </Grid>
                <Grid size={{ xs: 12 }}></Grid>
            </Grid>
        </>,
        minimumCredits: 0
    },
    Update: { screen: PortalTelemetryScreen.UpdateCpdForm, title: 'Update CPD', description: 'Please update your CPD details.', minimumCredits: 0.5 },
    Clone: { screen: PortalTelemetryScreen.CloneCpdForm, title: 'Clone CPD', description: 'Please update your CPD details to clone.', minimumCredits: 0.5 }
};
